import qs from "query-string";
import type { UUID } from "./utils/uuid";

// Part of the URL for this page to show which tab is active.
export enum PageUserSettingsTab {
    Users = "users",
    UserGroups = "user-groups",
}

export enum PageVehicleSettingsTab {
    Vehicles = "vehicles",
    VehicleGroups = "vehicle-groups",
}

/**
 * Path generators must be defined here so that they can be imported from `domain/`.
 * Otherwise, `/domain` would have to import `/pages` which would lead to circular
 * dependencies.
 */
export const routePath = {
    actionConfiguration: () => "/action-configuration",
    adminSettings: () => "/admin-settings",
    bulkImport: () => "/bulk-import",
    generalSettings: () => "/general-settings",
    fleetStatistics: () => "/fleet-statistics",
    columnVisibility: () => "/column-visibility",
    dashboard: () => "/dashboard",
    oldDashboard: (showTutorial?: boolean) =>
        qs.stringifyUrl({ url: "/legacy-dashboard", query: { showTutorial } }),
    dispatcher: () => "/start",
    helpAndTraining: () => "/help-and-training",
    impactManagement: () => "/impact-management",
    maintenance: () => "/maintenance",
    loginReport: () => "/login-report",
    motionSensors: () => "/motion-sensors",
    pedestrianDevices: () => "/pedestrian-devices",
    stationaryUnits: () => "/stationary-units",
    eloshieldClassicStationaryModules: () => "/eloshield-classic-stationary-modules",
    phones: () => "/phones",
    preOpsChecklists: () => "/pre-ops-checklists",
    safetyMessages: () => "/safety-messages",
    safetyMessagesSettings: () => "/safety-messages-settings",
    publicSettings: () => "/public_settings",
    settings: () => "/settings",
    shockProfiles: () => "/shock-profiles",
    sites: () => "/sites",
    userProductivity: () => "/user-productivity",
    userGroups: () => "/user-groups",
    user: (userId: string) => `/users/${userId}`,
    users: () => "/users",
    vehicleDevices: () => "/vehicle-devices",
    vehicleProductivity: () => "/vehicle-productivity",
    vehicleGroups: () => "/vehicle-groups",
    vehicleMovementPeriods: () => "/vehicle-movement-periods",
    vehicleDevice: (vehicleDeviceId: UUID) => `/vehicle-devices/${vehicleDeviceId}`,
    vehicle: (vehicleId: string) => `/vehicles/${vehicleId}`,
    vehicles: () => "/vehicles",
    systemWide: () => "/system-wide",
    userSettings: (tab?: PageUserSettingsTab) =>
        `/user-settings/${tab ?? PageUserSettingsTab.Users}`,
    vehicleSettings: (tab?: PageVehicleSettingsTab) =>
        `/vehicle-settings/${tab ?? PageVehicleSettingsTab.Vehicles}`,
    checklistSettings: () => "/checklist-settings",
    login: (): string => "/login",
    emailLoginTokenLogin: () => "/email-token-login",
    customizeUserList: () => "/customize-user-list",
    customizeVehicleList: () => "/customize-vehicle-list",
    customizeMaintenanceList: () => "/customize-maintenance-list",
    truckActivity: () => "/truck-activity",
    pedestrianActivity: () => "/pedestrian-activity",
    zoningActivity: () => "/zoning-activity",
    incidents: (incident?: string) => qs.stringifyUrl({ url: "/incidents", query: { incident } }),
    agv: () => "/agv",
    robots: () => "/robots",
};
